var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0454 32.8412L31.0836 15.474C31.3318 13.3597 29.6837 11.502 27.5601 11.502C25.4364 11.502 23.7883 13.3597 24.0365 15.474L26.0748 32.8412C26.1634 33.5963 26.8017 34.1653 27.5601 34.1653C28.3184 34.1653 28.9568 33.5963 29.0454 32.8412ZM27.5601 43.4972C29.0291 43.4972 30.22 42.3035 30.22 40.831C30.22 39.3584 29.0291 38.1647 27.5601 38.1647C26.091 38.1647 24.9002 39.3584 24.9002 40.831C24.9002 42.3035 26.091 43.4972 27.5601 43.4972Z",
    fill: "#CC2421"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 25.5,
    stroke: "#CC2421",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogout);
export default __webpack_public_path__ + "static/media/adminLogout.312df401bb1edf9c0329a30b5e0b9ed9.svg";
export { ForwardRef as ReactComponent };